<script setup lang="ts">
import type { Component } from 'vue'

export interface RowAction {
    key: string
    icon: Component
    label: string
    severity?: 'primary' | 'danger'
    visible?: boolean
}

defineProps<{
    actions: RowAction[]
}>()

const emit = defineEmits<{
    (e: 'action', key: string): void
}>()

function onClick(e: MouseEvent, key: string) {
    e.stopPropagation()
    emit('action', key)
}
</script>

<template>
    <div class="inline-flex items-center gap-0.5">
        <button
            v-for="a in actions.filter(x => x.visible !== false)"
            :key="a.key"
            type="button"
            :title="a.label"
            :class="[
                'w-7 h-7 rounded-6 flex items-center justify-center transition-all duration-fast',
                a.severity === 'danger' ? 'text-red hover:bg-red-l' : 'text-gray-500 hover:bg-gray-100 hover:text-teal'
            ]"
            @click="e => onClick(e, a.key)"
        >
            <component :is="a.icon" class="w-3.5 h-3.5" />
        </button>
    </div>
</template>
